import styled from 'styled-components';

import { COLOURS, isFocused } from '@belong/themes';
import TextInputUnstyled from '@belong/ui-components/components/forms/TextInputUnstyled';

import { StyledSendButton } from '../elements';

export const ChatInputContainer = styled.div`
  position: relative;
  display: flex;
  border-top: solid 1px ${COLOURS.GREY_400};
  border-bottom: solid 1px ${COLOURS.GREY_400};
`;

export const InputWrapper = styled.div<{ statusVisible?: boolean; disabled?: boolean }>`
  position: relative;
  display: flex;
  flex-grow: 1;

  ${props => props.disabled && `background: ${COLOURS.GREY_100};`}

  ${StyledSendButton} {
    opacity: 0;
  }

  :focus-within {
    ${StyledSendButton} {
      opacity: 1;
    }
  }
`;

export const StyledInput = styled(TextInputUnstyled)<{ attachmentButtonVisible?: boolean }>`
  z-index: 10;
  flex: 1;
  padding: 1.6rem;
  outline: none;

  ${({ attachmentButtonVisible }) => attachmentButtonVisible && `border-left: solid 1px ${COLOURS.GREY_400};`}
`;

// For focus outline to be outermost, wrapping both input and button
export const InputFocusOutline = styled.span`
  z-index: 1;
  position: absolute;
  top: -1px;
  right: 0;
  bottom: 0;
  left: 0;

  ${StyledInput}:not(:disabled):focus ~ & {
    ${isFocused()};
    outline-offset: -2px;
  }
`;
